import { paymentIntent } from '@/api/payment';

export default {
  namespaced: true,
  state: {
    loading: false,
    saveLoading: false,
    clientSecret: null,
    userTransactions: null,
    findByContentIdLoading: false,
    extrasClaims: [],
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setClientSecret(state, clientSecret) {
      state.clientSecret = clientSecret;
    },
    setSaveLoading(state, isLoading) {
      state.saveLoading = isLoading;
    },
    setUserTransactions(state, transactions) {
      state.userTransactions = transactions;
    },
    setFindByContentIdLoading(state, isLoading) {
      state.findByContentIdLoading = isLoading;
    },
    setExtrasClaims(state, transactions) {
      state.extrasClaims = transactions;
    },
  },
  actions: {
    async create({ commit, dispatch }, { PaymentIntentCreateParams, stripeAccount = null }) {
      try {
        commit('setLoading', true);
        await dispatch('payment/stripe/load', stripeAccount, { root: true });
        const { data } = await paymentIntent.create(PaymentIntentCreateParams, stripeAccount);
        commit('setClientSecret', data.client_secret);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
    async save({ commit, dispatch }, payload) {
      try {
        commit('setSaveLoading', true);
        await paymentIntent.save(payload);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setSaveLoading', false);
      }
    },
    async findByContentId({ commit, dispatch }, id) {
      try {
        commit('setFindByContentIdLoading', true);
        const { data } = await paymentIntent.findByContentId(id);
        commit('setExtrasClaims', data);
        await dispatch('payment/getUsers', { field: '_userId', payload: data }, { root: true });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setFindByContentIdLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading,
    clientSecret: state => state.clientSecret,
    saveLoading: state => state.saveLoading,
    userTransactions: state => state.userTransactions || [],
    findByContentIdLoading: state => state.findByContentIdLoading,
    extrasClaims: state => state.extrasClaims || [],
  },
};
